// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__35Grx","inputWrap":"styles_inputWrap__1c2fH","input":"styles_input__1UjNL"};